import * as React from "react";
import { forwardRef, memo } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFilledAnnouncementIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: "1rem",
	height: "1rem",
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M8.95322 8.62072C10.3108 7.26318 11.6673 5.90667 13.0248 4.54913C13.5447 4.02923 14.2967 4.2211 14.5123 4.92772C15.2643 7.39109 16.0132 9.8555 16.7735 12.3168C16.8633 12.6067 16.8117 12.812 16.595 13.0255C15.4902 14.1148 14.3947 15.2155 13.3013 16.3162C13.1249 16.4936 12.9412 16.5359 12.704 16.4637C10.2138 15.6993 7.72153 14.9401 5.23133 14.1778C4.54741 13.9683 4.36379 13.2101 4.87235 12.7016C6.23298 11.341 7.59362 9.98032 8.95425 8.61969L8.95322 8.62072Z",
			fill: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.97 19.3758C15.3552 19.9907 14.7569 20.59 14.1566 21.1873C14.0916 21.2523 14.0204 21.3152 13.9441 21.3647C13.5098 21.6463 12.9352 21.5617 12.6164 21.1739C12.277 20.7612 12.3018 20.1774 12.6783 19.7998C13.255 19.2201 13.8347 18.6434 14.4124 18.0647L14.5351 17.942C14.3536 17.7604 14.1813 17.5881 14.009 17.4159C13.7883 17.1941 13.7873 16.9733 14.009 16.7526C15.0303 15.7303 16.0515 14.709 17.0728 13.6888C17.3028 13.4588 17.5133 13.4608 17.7454 13.693C18.4798 14.4264 19.2143 15.1598 19.9467 15.8953C20.4615 16.4122 20.4604 17.159 19.9447 17.6779C19.2989 18.3267 18.6521 18.9746 18.0022 19.6203C17.4782 20.1402 16.7324 20.1361 16.2073 19.6152C16.132 19.5399 16.0567 19.4646 15.969 19.3769L15.97 19.3758Z",
			fill: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.22562 6.76481C5.90377 6.44297 5.58089 6.12112 5.26008 5.79824C4.98877 5.52591 4.9764 5.14423 5.2281 4.89562C5.4767 4.65011 5.85219 4.66455 6.1204 4.93172C6.76925 5.57852 7.41604 6.22634 8.06284 6.87416C8.33001 7.14237 8.34033 7.51579 8.09275 7.7644C7.84414 8.01404 7.46762 8.00475 7.20251 7.74067C6.8755 7.41573 6.55159 7.08976 6.22562 6.76378V6.76481Z",
			fill: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M2.54104 8.15955C2.66586 8.04298 2.86082 7.97903 3.08054 8.03783C4.00173 8.28128 4.92292 8.52679 5.84101 8.77849C6.16595 8.86824 6.34441 9.19318 6.26292 9.51193C6.18039 9.83378 5.86783 10.038 5.54186 9.95344C4.61035 9.71206 3.67885 9.46551 2.75251 9.20453C2.30997 9.07971 2.17999 8.52266 2.54104 8.16058V8.15955Z",
			fill: "#1F3B44"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M9.23484 5.78807C9.18636 5.68388 9.12137 5.58382 9.09145 5.47447C8.84697 4.57907 8.60662 3.68265 8.36833 2.78519C8.27652 2.43858 8.45704 2.11673 8.78611 2.02389C9.11827 1.93002 9.44837 2.11983 9.54328 2.46953C9.78982 3.37421 10.0322 4.28095 10.2726 5.1877C10.3479 5.47138 10.2293 5.74165 9.98479 5.87781C9.73824 6.01501 9.45559 5.97581 9.23484 5.7891V5.78807Z",
			fill: "#1F3B44"
		})
	]
});
const ForwardRef = forwardRef(SvgFilledAnnouncementIcon);
const Memo = memo(ForwardRef);
export default Memo;
